export default [
    {
        name: 'administracao-permissao-acesso',
        path: 'permissao-acesso',
        redirect: 'permissao-acesso/index',
        component: () => import(/* webpackChunkName: 'administracao-permissao-acesso' */ '@/views/administracao/permissao-acesso/Index'),
        children: [
            {
                meta: {title: 'Lista de permissões de acessos'},
                name: 'administracao-permissao-acesso-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'administracao-permissao-acesso' */ '@/views/administracao/permissao-acesso/List'),
            },
            {
                meta: {title: 'Edição de permissão de acesso'},
                name: 'administracao-permissao-acesso-edit',
                path: 'edit/:id',
                props: route => ({id: parseInt(route.params.id)}),
                component: () => import(/* webpackChunkName: 'administracao-permissao-acesso' */ '@/views/administracao/permissao-acesso/Form'),
            },
        ],
    },
]